/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithAllotmentItemRequestBuilder, WithAllotmentItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /PoolingHistory/allotment
 */
export interface AllotmentRequestBuilder extends BaseRequestBuilder<AllotmentRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.PoolingHistory.allotment.item collection
     * @param allotmentId Unique identifier of the item
     * @returns {WithAllotmentItemRequestBuilder}
     */
     byAllotmentId(allotmentId: number) : WithAllotmentItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentRequestBuilderUriTemplate = "{+baseurl}/PoolingHistory/allotment";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AllotmentRequestBuilderNavigationMetadata: Record<Exclude<keyof AllotmentRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAllotmentId: {
        requestsMetadata: WithAllotmentItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["allotmentId"],
    },
};
/* tslint:enable */
/* eslint-enable */
